import { FloralOrnament } from "./Ornaments";

const MAIN_IMG =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_gold-wedding-suite/artifacts/7ppvrg0o_att.39wOp5uGDPIbImnsgwmRKUc6kZ_McMIwG2U-S2r_BuU.jpeg";
const LEFT_IMG =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_gold-wedding-suite/artifacts/q5yfqs7c_att.TLih6eBVfn_9giCGinkYy4o2XniYur21C0ivkdMzM2g.webp";
const RIGHT_IMG =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_gold-wedding-suite/artifacts/f99fq6y8_att.A4XRr3U10rhD_TGQxp1DK00tcUBxhN4uG7ufaNXCGBQ.webp";

export default function CouplePhoto({ details }) {
  const alt = `${details.name1} და ${details.name2}`;
  return (
    <section data-testid="couple-photo-section" className="space-y-8 text-center">
      <FloralOrnament className="mx-auto opacity-80" />

      <div className="relative mx-auto h-[330px] w-full max-w-[340px] sm:h-[370px]">
        <div
          data-testid="couple-photo-left"
          className="absolute left-0 top-10 w-[32%] max-w-[120px] -rotate-[9deg] border border-[#EFE6D2] bg-white p-2 pb-4 shadow-[0_18px_36px_-14px_rgba(28,25,23,0.22)]"
        >
          <div className="aspect-[3/4] w-full overflow-hidden border border-[#F1EBDC] bg-[#FAF7F0]">
            <img src={LEFT_IMG} alt={alt} className="h-full w-full object-cover" loading="lazy" />
          </div>
        </div>

        <div
          data-testid="couple-photo-right"
          className="absolute right-0 top-14 w-[32%] max-w-[120px] rotate-[8deg] border border-[#EFE6D2] bg-white p-2 pb-4 shadow-[0_18px_36px_-14px_rgba(28,25,23,0.22)]"
        >
          <div className="aspect-[3/4] w-full overflow-hidden border border-[#F1EBDC] bg-[#FAF7F0]">
            <img src={RIGHT_IMG} alt={alt} className="h-full w-full object-cover" loading="lazy" />
          </div>
        </div>

        <div className="absolute left-1/2 top-0 z-10 w-[58%] max-w-[210px] -translate-x-1/2">
          <div className="-rotate-2 border border-[#EFE6D2] bg-white p-2.5 pb-6 shadow-[0_26px_50px_-18px_rgba(28,25,23,0.25)] transition-transform duration-500 hover:rotate-0">
            <p className="font-display pb-2 text-center text-[9px] uppercase tracking-[0.35em] text-[#A1A1AA]">
              06 · 10 · 2026
            </p>
            <div className="aspect-[3/4] w-full overflow-hidden border border-[#F1EBDC] bg-[#FAF7F0]">
              <img
                src={MAIN_IMG}
                alt={alt}
                className="h-full w-full object-cover"
                style={{ objectPosition: "center 35%" }}
              />
            </div>
          </div>

          <div data-testid="couple-heart-tag" className="absolute -bottom-6 -right-4 rotate-[7deg]">
            <div className="relative h-[92px] w-[96px]">
              <svg
                viewBox="0 0 100 96"
                className="h-full w-full drop-shadow-[0_10px_18px_rgba(28,25,23,0.16)]"
                aria-hidden="true"
              >
                <path
                  d="M50 90 C22 64 5 45 5 27 C5 13 15 5 27 5 C37 5 45 11 50 21 C55 11 63 5 73 5 C85 5 95 13 95 27 C95 45 78 64 50 90 Z"
                  fill="#FFFFFF"
                  stroke="#D9C9A3"
                  strokeWidth="1"
                />
                <circle cx="50" cy="9" r="2" fill="none" stroke="#C9A94E" strokeWidth="0.9" />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-[1px] pb-3 leading-tight">
                <span className="font-sans-geo text-[9.5px] font-light tracking-[0.1em] text-[#6B6560]">
                  {details.name1}
                </span>
                <span className="font-script text-[13px] leading-none text-[#B8860B]">&amp;</span>
                <span className="font-sans-geo text-[9.5px] font-light tracking-[0.1em] text-[#6B6560]">
                  {details.name2}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
